export const removeAllReference = <T>(value?: T):T => JSON.parse(JSON.stringify(value ?? {}))